import { IslandComponent } from '@island-runtime/types';

/**
 * `data-react-island="TrialMonthlyRebillPopup"` — renders nothing. The island
 * root (`island-runtime/IslandRoot.tsx`) mounts `Popups` / `Toasts` on every
 * page that has at least one island; this one exists for pages with no other
 * island, so that the root is created at all and the celebration can open.
 *
 * It takes no `data-props`: the host decides server-side and opens the popup
 * with `AiTools.Popups.openPopup('TrialMonthlyRebillPopup')`, a call that waits
 * for whichever bundle serves the page (`usePopupHostApi`).
 *
 * Mount it only on pages **without** the SPA bundle — the full app renders
 * `Popups` itself, so the island would be a second host on the page.
 */
const TrialMonthlyRebillPopupIsland: IslandComponent = () => null;

export default TrialMonthlyRebillPopupIsland;
